<template>
  <!-- 我的申请 -->
  <div class="box">
    <div class="t1">{{ $t('我的申请') }}</div>

    <div>
      <div class="list" v-if="userData">

        <div class="t2 df aic jcsb">
          {{ $t('专家申请') }}
          <div>
            <template v-if="userData.tesa_status === 20">
              <el-button class="fs-12 c-19 pt-0 pb-0 mr-20" type="text" @click="handleOpen">+
                {{ $t('上传宣传账号') }}
              </el-button>
            </template>
            <span class="date">{{ userData.create_time }}</span>
          </div>
        </div>

        <div class="mt-10 df aic jcsb">
          <div class="" style="width: 390px;">
            <el-steps :active="((userData.tesa_status == 10 || userData.tesa_status == 40) ? 2 : 3)">
              <el-step :title="$t('提交内容')" icon="iconfont icon-24gl-circle"></el-step>
              <template v-if="userData.tesa_status != 40">
                <el-step :title="$t('审核中')" icon="iconfont icon-24gf-circle"
                         v-if="userData.tesa_status == 10 && userData.tesa_status != 20"></el-step>
                <el-step :title="$t('审核中')" icon="iconfont icon-24gl-circle" v-else></el-step>
              </template>
              <el-step :title="$t('结束审核')" icon="iconfont icon-24gl-circle" v-if="userData.tesa_status == 10"></el-step>
              <el-step :title="$t('通过')" icon="iconfont icon-tongguo" class="tongguo"
                       v-if="userData.tesa_status == 20"></el-step>
              <el-step :title="$t('驳回')" style="color: #D80F05;" class="bohui" icon="iconfont icon-weitongguo"
                       v-if="userData.tesa_status == 30"></el-step>
              <el-step :title="$t('已撤销')" icon="iconfont icon-24gl-circle" v-if="userData.tesa_status == 40"></el-step>
            </el-steps>
            <div v-if="userData.tesa_status == 30" class="reason">
              {{ $t('驳回理由') }}:{{ userData.tesa_reject_reason }}

            </div>
          </div>
          <div class="btn df">

            <!-- <el-button class="btn1 disable" :disabled="userData.tesa_status != 10" @click="handleCancelApply">{{
      $t('撤销申请')
    }}</el-button>
            <el-button class="btn2 m  l-12 disable" :disabled="userData.tesa_status = 20" @click="handleApplication">{{
      $t('进入编辑')
    }}</el-button> -->

            <el-button :class="{ 'disable': userData.tesa_status != 10, 'btn1': 'true' }"
                       :disabled="userData.tesa_status != 10" @click="handleCancelApply">{{ $t('撤销申请')
              }}</el-button>
            <el-button :class="{ 'disable': userData.tesa_status == 20, 'l-12': 'true', 'm': 'true', 'btn2': 'true' }"
                       :disabled="userData.tesa_status == 20" @click="handleApplication">{{ $t('进入编辑')
              }}</el-button>

          </div>
        </div>
      </div>
    </div>


    <!-- 上传宣传账号 -->


    <posterModel ref="posterDialog" :promotion_detail="promotion_detail" :data="data_list"
                 @poster-submitted="handleposterSubmitted" @clearPromotion="clearPromotion"></posterModel>

  </div>
</template>

<script>
import posterModel from "@/components/posterModel.vue";
import { addPromotion, cancelApply, commonData, getExpertInfo, promotionDetail } from "@api/expert";
import { getMyInfo } from "@api/home";
import { } from "@api/home";

export default {
  components: { posterModel },
  data() {
    return {
      active: 1,

      data_list: {},
      userData: [],
      promotion_detail: [],
    }
  },
  mounted() {
    getMyInfo().then((res) => {
      if (res.status == 200) {
        if (res.data.length == 0) {
          let str = '/cn';
          let Language = localStorage.getItem('currentLanguage');  //获取本地语言
          if (Language && Language != 'zh') {
            str = '/' + Language;
          }
          this.$router.push(str + '/stationed/index/');
        }else {
          this.getUserData();
        }
      }
    });
  },
  methods: {
    async getUserData() {
      const info = await getExpertInfo({ user_id: this.userId });
      if (info.status == 200) {
        this.userData = info.data;
      }
    },
    // 跳转申请页面
    handleApplication() {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      this.$router.push(str + '/stationed/application');
    },
    async handleCancelApply() {
      const res = await cancelApply();
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getUserData();
      } else {
        this.$message.error(res.msg);
      }
    },
    async getCommon() {
      let res = await commonData();
      if (res.status == 200) {
        this.data_list = res.data;
      }
      let promotion_detail = await promotionDetail({user_id: this.userId});
      if (promotion_detail.status == 200) {
        this.promotion_detail = promotion_detail.data;

      }
      this.$refs.posterDialog.openModal();
    },
    handleOpen() {
      this.getCommon();
    },
    async handleposterSubmitted(content) {
      let res = await addPromotion({content: content});
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.$emit('addPromotion');
      }
    },
    clearPromotion() {
      this.$emit('clearPromotion');
    },
  }
}
</script>

<style lang="scss" scoped>
.reason {
  color: rgb(89, 89, 89);
  font-family: "harmonyos";
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
}

.btn {

  .btn1,
  .btn2 {
    min-width: 92px;
    height: 32px;
    border: 1px solid rgb(174, 174, 174);
    border-radius: 23px;
    padding: 0 16px;
    font-size: 12px;
    color: #000000;

    &:hover {
      color: #D80F05;
      border: 1px solid #D80F05;
    }
  }

  .disable {
    border: 1px solid rgb(174, 174, 174);
    color: rgb(174, 174, 174);

    &:hover {
      border: 1px solid rgb(174, 174, 174);
      color: rgb(174, 174, 174);
    }
  }

  .btn1 {
  }
}

::v-deep() {
  .el-steps {
    .is-horizontal:nth-child(n+2) {
      .el-step__main {
        position: relative;
        left: -50%;
        padding-left: 14px;
        text-align: center;
      }
    }

    .is-horizontal:last-child {
      .el-step__main {
        position: relative;
        left: 0%;
        padding-left: 0px;
      }
    }

    .tongguo .el-step__main {
      .el-step__title {
        color: #058358;
      }
    }

    .bohui .el-step__main {
      .el-step__title {
        color: #D80F05;
      }
    }
  }

  .el-step__title {
    color: rgb(216, 15, 5);
    font-family: "harmonyos";
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }

  .el-step__icon.is-icon {
    width: 24px;
  }

  .el-step__head.is-finish {
    .el-step__icon.is-icon {
      width: 14px;
      padding-right: 6px;
      padding-left: 6px;
    }

  }

  .el-step__icon.is-icon {
    font-size: 8px;

    .iconfont {
      font-size: 8px;
      color: #D80F05;
      position: relative;
      top: -2px;
    }
  }

  .el-step__title.is-finish {
    color: #191919;
  }

  .is-flex {
    .el-step__icon.is-icon {
      .iconfont {
        font-size: 8px;
        color: rgb(174, 174, 174);
        background: rgb(243, 243, 243);
        background: transparent;
      }

      .iconfont.icon-tongguo {
        color: #058358;
        font-size: 10px;
      }

      .iconfont.icon-weitongguo {
        font-size: 10px;
        color: #D80F05;
      }
    }

    .el-step__title {
      position: relative;
      right: 10px;
      color: #595959;
    }

    .el-step__head.is-wait {
    }
  }

}

.box {
  border: 1px solid rgb(243, 243, 243);
  border-radius: 8px;
  /* shadow-l */
  box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
  background: rgb(255, 255, 255);
  padding: 24px 40px;
  margin-top: 16px;

  .list {
    // height: 107px;
    border: 0.5px solid rgb(201, 201, 201);
    border-radius: 8px;
    background: rgb(255, 255, 255);
    padding: 16px 20px;
    margin-top: 28px;

    .t2 {
      color: rgb(25, 25, 25);
      font-size: 16px;
      font-family: "MicrosoftYaHeiSemibold";
      line-height: 22px;

      .date {
        color: rgb(119, 119, 119);

        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
}

.t1 {
  color: rgb(25, 25, 25);
  font-family: "MicrosoftYaHeiSemibold";
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
}
</style>